import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Avaliacoes.module.css";
import Alerta from "../../components/alerta/Alerta";
import BotaoPaginaNovo from "../../components/botaoPaginaNovo/BotaoPaginaNovo";
import { Link } from "react-router-dom";
import AvaliacaoApi from "../../services/AvaliacaoApi";
import { IoEyeSharp } from "react-icons/io5";
import Loader from "../../components/loader/Loader";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Avaliacoes() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    const [avaliacoes, setAvaliacoes] = useState([]);
   
    async function ListarAvaliacoes() {
        try {
            const listaAvaliacoes = await AvaliacaoApi.ListarAvaliacoes();
            setAvaliacoes(listaAvaliacoes);
        } catch {
            console.error("Erro ao buscar alunos");
        }
    }

    useEffect(() => {
        ListarAvaliacoes();
    }, []);


    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Avaliações</h4>
                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Data Realizada</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {avaliacoes
                                        .filter((avaliacao) => avaliacao.tipoAvaliacaoEnum === 1)
                                        .map((avaliacao) => (
                                            <tr className={style.tabela_corpo} key={avaliacao.id}>
                                                <td title={new Date(avaliacao.dataRealizada).toLocaleString("pt-BR")}>
                                                    {new Date(avaliacao.dataRealizada).toLocaleDateString("pt-BR")}
                                                </td>
                                                <td className={style.coluna_acoes}>
                                                    <Link
                                                        to="/avaliacao/aluno"
                                                        state={avaliacao.id}
                                                        className={style.botao_visualizar}
                                                    >
                                                        <IoEyeSharp title="Visualizar" />
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </Topbar>
        </Sidebar>
    );
}

export default Avaliacoes;
